/* Kept apart from the component so the left rail's query can interpolate it without
 * importing the component that renders it, which would make the two modules' load order
 * decide whether this fragment exists yet.
 */
import { gql } from '@apollo/client';

export const PatientLeftRailEpisode = gql`
    fragment PatientLeftRailEpisode on EpisodeOfCare {
        id
        startDate
        endDate
        notes
        numberInSequence
        typeLabel
        permissions {
            id
            editNotes
        }
        status
        frequencyOrders: orders(
            filters: { orderType: { exact: FREQUENCY }, isDiscontinued: { inList: [true, false] } }
        ) {
            items {
                ...PatientLeftRailOrderFragment
                frequency {
                    intervalCount
                    intervalUnit
                    numVisitsPerInterval
                    unitsPerInterval
                }
            }
        }
        prnOrders: orders(
            filters: { orderType: { exact: PRN }, isDiscontinued: { inList: [true, false] } }
        ) {
            items {
                ...PatientLeftRailOrderFragment
                numActiveOccurrences
                prn {
                    authorizedVisitCount
                }
            }
        }
    }
    fragment PatientLeftRailOrderFragment on Order {
        id
        orderType
        discipline {
            id
            code
        }
        isDiscontinued
        discontinuedAt
    }
`;
